import jwtDecode from 'jwt-decode';
import { LOCAL_STORAGE } from 'constants/general';
import { ROUTES } from 'constants/routes';
import { ProjectInvitationToken } from 'interfaces/project.interface';
import {
  getLocalStorage,
  removeLocalStorage,
  updateLocalStorage
} from 'utils/helpers/storage';
import { areInviteEmailsEqual } from 'utils/projects/project.util';

export interface StoredInvitationResume {
  storageKey: string;
  acceptRoute: string;
}

export const STORED_INVITATION_RESUMES: StoredInvitationResume[] = [
  {
    storageKey: LOCAL_STORAGE.INVITATION_TOKEN,
    acceptRoute: ROUTES.ACCEPT_INVITE
  },
  {
    storageKey: LOCAL_STORAGE.PROJECT_INVITATION_TOKEN,
    acceptRoute: ROUTES.ACCEPT_PROJECT_INVITE
  }
];

interface StoredInvitationPayload {
  email?: string;
  token?: string;
}

export const decodeProjectInviteToken = (
  token: string
): ProjectInvitationToken | null => {
  try {
    return jwtDecode<ProjectInvitationToken>(token);
  } catch {
    return null;
  }
};

export const stashProjectInviteToken = (email: string, token: string) => {
  updateLocalStorage(
    LOCAL_STORAGE.PROJECT_INVITATION_TOKEN,
    JSON.stringify({ email, token })
  );
};

export const clearProjectInviteToken = () => {
  removeLocalStorage([LOCAL_STORAGE.PROJECT_INVITATION_TOKEN]);
};

const parseStoredInvitation = (
  invitationData: string
): StoredInvitationPayload | null => {
  try {
    return JSON.parse(invitationData) as StoredInvitationPayload;
  } catch {
    return null;
  }
};

const getMatchingInvitePath = (
  invitations: StoredInvitationResume[],
  userEmail: string
): string | null => {
  for (const { storageKey, acceptRoute } of invitations) {
    const invitationData = getLocalStorage(storageKey);
    if (!invitationData) {
      continue;
    }
    const parsedData = parseStoredInvitation(invitationData);
    if (
      !parsedData?.token ||
      !areInviteEmailsEqual(parsedData.email, userEmail)
    ) {
      continue;
    }
    const queryParams = new URLSearchParams({ token: parsedData.token });
    return `${acceptRoute}?${queryParams.toString()}`;
  }
  return null;
};

export const resumeStoredInvitations = ({
  invitations,
  userEmail,
  navigate
}: {
  invitations: StoredInvitationResume[];
  userEmail: string;
  navigate: (path: string) => void;
}) => {
  const path = getMatchingInvitePath(invitations, userEmail);
  if (path) {
    navigate(path);
  }
};
